import script from "./AddProgramPop.vue?vue&type=script&setup=true&lang=js"
export * from "./AddProgramPop.vue?vue&type=script&setup=true&lang=js"

import "./AddProgramPop.vue?vue&type=style&index=0&id=0bbb8906&lang=scss"

const __exports__ = script;

export default __exports__